export interface IGpsDevice {
    id: number,
    imei: string,
    gpsNumber: number,
    vendorId: number,
    vendor: string
}